/**
 * Replaces [nbEmployee] shortcodes with styled employee count display
 *
 * @param props - Function parameters
 * @param props.context - Shortcode context containing text
 * @param props.nbEmployee - Number of employees to display
 *
 * @returns void - Updates the context.text directly with the replaced shortcodes
 *
 * Styling:
 * - Wraps number in a styled span element
 * - Applies a light background and border
 * - Uses rounded corners for pill-like appearance
 *
 * @example
 * ```ts
 * applyNbEmployee({
 *   context: { text: "Pricing for [nbEmployee] employees", locale: "en" },
 *   nbEmployee: 5
 * });
 * // Result: "Pricing for <span class="border bg-[#F7F9FC] ...">5</span> employees"
 * ```
 */
import { classNames } from '@payfit/growth-platform-brand-system-v2';
import { ShortcodeContext } from '../..';
import { numberEmployeeStyle } from 'apps/website/src/components/BlockComponents/TablePriceBlockComponent/scripts/commonStyles';
import { applyShortcode } from '../../utils/applyShortcode';
export const applyNbEmployee = ({
  context,
  nbEmployee,
}: {
  context: ShortcodeContext;
  nbEmployee: number;
}) => {
  context.text = applyShortcode(context.text, 'nbEmployee', () => {
    return `<span class="${classNames(numberEmployeeStyle)}">${nbEmployee}</span>`;
  });
};
